import Button from '@/components/Button';
import ensureSelectedFilterOptions from '@/components/modals/workflowLogsModal/lib/ensureSelectedFilterOptions';
import useWorkflowLogsFilters from '@/components/modals/workflowLogsModal/lib/useWorkflowLogsFilters';
import { FiTag } from '@/components/react-icons/main/index.esm';
import FloatingSelectV2 from '@/components/v2/FloatingSelectV2';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import workflowScreenSelectors from '@/screens/workflows/redux/selectors/workflowScreenSelectors';
import selectors from '@/redux/selectors/selectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const SnapshotFilter = () => {
  const workflowId = useArgSelector(selectors.workflowId);
  const snapshotFilter = useArgSelector(selectors.pref, `workflowLogsSnapshotFilter-${workflowId}`);
  const workflowLogsMetadataSnapshots = useSelector(selectors.workflowLogsMetadataSnapshots);
  const workflowSnapshots = useSelector((state) => workflowScreenSelectors.activeWorkflowSnapshots(state)) || [];
  const { handleFilterChange } = useWorkflowLogsFilters();

  const hasSnapshotFilter = snapshotFilter?.length > 0;

  const snapshotOptions = useMemo(() => {
    const options = workflowLogsMetadataSnapshots
      ?.map((metadata) => {
        const label = `${metadata?.label || 'Draft'}`;
        const value = metadata?.id || 'draft';

        return { label, value, totalCount: metadata?.totalCount };
      })
      .sort((a, b) => {
        const versionA = a.label.split('.').map(Number);
        const versionB = b.label.split('.').map(Number);

        for (let i = 0; i < Math.max(versionA?.length, versionB?.length); i++) {
          const numA = versionA[i] || 0;
          const numB = versionB[i] || 0;
          if (numA !== numB) {
            return numB - numA;
          }
        }
        return 0;
      });

    return ensureSelectedFilterOptions({
      options,
      selectedValues: snapshotFilter,
      getSelectedOption: (value) => {
        if (value === 'draft') {
          return { label: 'Draft' };
        }

        const snapshot = workflowSnapshots.find((workflowSnapshot) => workflowSnapshot.id === value);
        return { label: snapshot?.version || value };
      }
    });
  }, [workflowLogsMetadataSnapshots, snapshotFilter, workflowSnapshots]);

  const handleSnapshotChange = (value) => {
    handleFilterChange('snapshot', value);
  };

  return (
    <>
      <Button className={`outline filter snapshot-filter ${hasSnapshotFilter ? 'active' : ''}`} size="sm" icon={FiTag}>
        Version
      </Button>
      <FloatingSelectV2 multiple triggers={[`.snapshot-filter`]} options={snapshotOptions} onChange={handleSnapshotChange} useSearch={snapshotOptions?.length > 5} value={snapshotFilter} placement="bottom" offset={4} />
    </>
  );
};

export default SnapshotFilter;
